import axios from "axios";
import storage from "./Storage";

class Call {
  constructor(base_url) {
    this.base_url = base_url;
  }

  header() {}

  format_response(resp, args) {
    return {
      status: resp.status_code >= 200 && resp.status_code <= 299 ? true : false,
      data: resp.data,
      code: resp.status_code,
      response: resp,
      request: args,
    };
  }

  async call(method, route, args, altHeader = {}) {
    try {
      return await axios({
        method: method,
        url: `${this.base_url}${route}`,
        data: args.data,
        headers: { ...this.header(), ...altHeader },
        params: args.params,
      });
    } catch (err) {
      if (err.response.status === 401) {
        storage.remove("token");
        storage.remove("app-token");
        window.location.href = "/login";
      }
      return err;
    }
  }
}

export default Call;
